const initialState = {
    options: [],
    selected: null,
    selections: [],
    tempSelected: null,
    tempSelections: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_SELECTION":
            return {
                ...state,
            };
        case "SET_SELECTION":
            return {
                ...state,
                options: action.options,
                selected: action.selected,
                selections: action.selections,
                tempSelected: action.selected,
                tempSelections: action.selections,
            };
        case "SET_TEMP_SELECTION":
            return {
                ...state,
                options: action.options,
                tempSelected: action.selected,
                tempSelections: action.selections,
            };
        case "SAVE_TEMP":
            return {
                ...state,
                selected: state.tempSelected,
                selections: state.tempSelections,
            };
        case "RESET_WORKING":
            return {
                ...state,
                options: action.options,
                tempSelected: state.selected,
                tempSelections: state.selections,
            };
        case "CLEAR":
            return {
                ...state,
                options: action.options,
                tempSelected: null,
                tempSelections: [],
            };
        default:
            return state;
    }
};

export { reducer, initialState };
